import { IconWrapper } from '../runtime';
export default IconWrapper('full-screen', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.75 1.75024H12.75C13.5784 1.75024 14.25 2.42182 14.25 3.25024V6.25024M6.25 14.2502H3.25C2.42157 14.2502 1.75 13.5787 1.75 12.7502V9.75024M6.25 1.75024L3.25 1.75024C2.84064 1.75024 2.46958 1.91423 2.19893 2.18008M1.75 6.25024L1.75 3.25024C1.75 2.83118 1.92185 2.45225 2.19893 2.18008M2.19893 2.18008L6 6.00024M14.25 9.75024V12.7502C14.25 13.1645 14.0821 13.5395 13.8107 13.8109M9.75 14.2502H12.75C13.1642 14.2502 13.5392 14.0824 13.8107 13.8109M13.8107 13.8109L10 10.0002",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});